import { render } from "./wallet-card-loading.vue?vue&type=template&id=7ef8e5e6&scoped=true"
import script from "./wallet-card-loading.vue?vue&type=script&lang=js"
export * from "./wallet-card-loading.vue?vue&type=script&lang=js"

import "./wallet-card-loading.vue?vue&type=style&index=0&id=7ef8e5e6&lang=scss&scoped=true"
import "./wallet-card-loading.vue?vue&type=style&index=1&id=7ef8e5e6&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef8e5e6"]])

export default __exports__